<header class="header-producers-page">
  <div class="header-producers-page__cover-image" [style.background-image]="'url(' + coverImageUrl() + ')'">
    @if (isLoggedIn() && !isOwnProfile()) {
      <div class="header-producers-page__follow-producer">
        <button type="button" mat-raised-button class="pill" (click)="handleFollowProducerClick()">
          <mat-icon>{{ isFollowed() ? "notifications_active" : "notifications" }}</mat-icon>
          {{ isFollowed() ? "Deixar de seguir" : "Seguir" }}
        </button>
      </div>
    }

    <div class="header-producers-page__profile-picture-container">
      <img
        [src]="profileImageUrl()"
        alt="Profile Picture"
        class="header-producers-page__profile-picture-container__profile-picture" />
    </div>
  </div>
  <div
    class="header-producers-page__blurred-background"
    [style.background-image]="'url(' + coverImageUrl() + ')'"></div>

  <div class="header-producers-page__profile">
    <div class="header-producers-page__profile-info">
      <h1 class="header-producers-page__profile-info__name">{{ name() }}</h1>
      <div class="header-producers-page__profile-info__bio">
        <p>Produzindo eventos desde {{ producerSince() }}</p>
        <p>Mais de {{ numberOfEvents() }} eventos realizados</p>
      </div>

      @if (socialLinks().length > 0) {
        <div class="header-producers-page__profile-info__social">
          <p class="header-producers-page__profile-info__social-title">Redes sociais</p>
          <div class="header-producers-page__profile-info__social-links">
            @for (link of socialLinks(); track link.label) {
              <a
                class="header-producers-page__profile-info__social-link"
                [href]="link.url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="link.label">
                <i [class]="link.icon"></i>
              </a>
            }
          </div>
        </div>
      }
    </div>
  </div>
</header>
